function getQuarter(duration, currentTime) {
    const FirstQuarter  = Math.trunc(duration / 4) ;
    const secondQuarter = FirstQuarter * 2;
    const ThirdQuarter = FirstQuarter * 3;
    const FourthQuater = FirstQuarter * 4;
    const currentTimeTrunced= Math.trunc(currentTime);
    if (currentTimeTrunced === FirstQuarter) {
        return 1
    }
    if (currentTimeTrunced === secondQuarter) {
        return 2
    }
    if (currentTimeTrunced === ThirdQuarter) {
        return 3
    }
    if (currentTimeTrunced === FourthQuater) {
        return 4
    }
    return 0
}


export function getTheExactQuarter(duration, currentTime) {
        return getQuarter(duration, currentTime);
}